import React from 'react';

/**
 * Site-wide footer required for compliance with RAW COMPANY TECH LIMITED branding.
 * Includes schema.org Organization structured data.
 */
export const Footer = () => {
  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "RAW COMPANY TECH LIMITED",
    "legalName": "RAW COMPANY TECH LIMITED",
    "url": "https://rawcompanytech.com",
    "identifier": {
      "@type": "PropertyValue",
      "name": "Company Number",
      "value": "17349121"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "GB",
      "addressRegion": "England & Wales"
    },
    "subOrganization": {
      "@type": "Organization",
      "name": "Raw Mixes",
      "url": "https://rawmixes.uk"
    }
  };

  return (
    <footer
      className="mt-16 border-t border-white/5 bg-[#050505] text-[#A1A1AA]"
      data-testid="site-footer"
      itemScope
      itemType="https://schema.org/Organization"
    >
      <meta itemProp="name" content="RAW COMPANY TECH LIMITED" />
      <meta itemProp="url" content="https://rawcompanytech.com" />
      <meta itemProp="identifier" content="17349121" />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />

      <div className="max-w-[1600px] mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
        <p className="text-xs md:text-sm leading-relaxed">
          © 2026{' '}
          <span itemProp="legalName" className="font-bold text-white">
            RAW COMPANY TECH LIMITED
          </span>
          . Registered in England &amp; Wales (Company No. 17349121).
        </p>
        <nav className="flex items-center gap-5 text-xs md:text-sm">
          <a
            href="/about"
            className="text-[#A1A1AA] hover:text-white transition-colors"
            data-testid="footer-about-link"
          >
            About
          </a>
          <a
            href="https://rawcompanytech.com"
            target="_blank"
            rel="noopener noreferrer me"
            className="text-[#FFB000] hover:text-[#E69E00] font-bold transition-colors"
            data-testid="footer-parent-link"
            itemProp="url"
          >
            rawcompanytech.com →
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
